function AccountFooter() {
  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="footerLinkSec justifyCenter">
            <p className="copyRgtTxt mobHide">
              &copy; 2025 TClub Inc. All rights reserved.
            </p>
            <p className="copyRgtTxt desktopHide">&copy; 2025 TClub Inc.</p>
            <a
              href="mailto:support@timesclub.co"
              className="footLink link_underLine"
            >
              Contact Us
            </a>
            <a href="/legal" className="footLink link_underLine mobLink">
              Legal
            </a>
            <a
              id="terms"
              href="/tnc"
              className="footLink link_underLine deskTopLink"
            >
              Terms & Conditions
            </a>
            <a
              id="terms"
              href="/remittance_tnc"
              className="footLink link_underLine deskTopLink"
            >
              Remittance Terms & Conditions
            </a>
            <a
              id="privacy"
              href="/privacy"
              className="footLink link_underLine deskTopLink"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default AccountFooter;
